import {
  BIControlPanelModel,
  BIApprovalFilterOptionsState,
  BIApprovalFilter,
  BIApprovalState,
  BIApprovalTableState,
  BIFilterOptionFieldState,
  BIFilterOptionPagination,
  BIParametersFilterOptionsState,
  BIParametersFilter,
  BIParametersState,
  BIParametersTableState,
  BITablePagination,
} from './bi-control-panel-types';

export const BI_AUTOCOMPLETE_PAGE_SIZE = 20;
export const BI_TABLE_DEFAULT_PAGE_SIZE = 10;

export const defaultFilterOptionPagination = (): BIFilterOptionPagination => ({
  page: -1,
  size: BI_AUTOCOMPLETE_PAGE_SIZE,
  totalElements: 0,
  hasNext: true,
});

export const defaultFilterOptionFieldState = (): BIFilterOptionFieldState => ({
  items: [],
  loading: false,
  initialized: false,
  searchInput: '',
  pagination: defaultFilterOptionPagination(),
});

export const defaultTablePagination = (): BITablePagination => ({
  page: 0,
  size: BI_TABLE_DEFAULT_PAGE_SIZE,
  totalElements: 0,
  totalPages: 0,
  hasMore: true,
});

export const defaultParametersFilter = (): BIParametersFilter => ({
  financialGroup: null,
  contract: null,
  subcontract: null,
  carrier: null,
  competency: null,
});

export const defaultApprovalFilter = (): BIApprovalFilter => ({
  financialGroup: null,
  contract: null,
  carrier: null,
  competency: null,
});

export const defaultParametersFilterOptions = (): BIParametersFilterOptionsState => ({
  financialGroup: defaultFilterOptionFieldState(),
  contract: defaultFilterOptionFieldState(),
  subcontract: defaultFilterOptionFieldState(),
  carrier: defaultFilterOptionFieldState(),
  competency: defaultFilterOptionFieldState(),
});

export const defaultApprovalFilterOptions = (): BIApprovalFilterOptionsState => ({
  financialGroup: defaultFilterOptionFieldState(),
  contract: defaultFilterOptionFieldState(),
  carrier: defaultFilterOptionFieldState(),
  competency: defaultFilterOptionFieldState(),
});

export const defaultParametersTableState = (): BIParametersTableState => ({
  rows: [],
  loading: false,
  pagination: defaultTablePagination(),
});

export const defaultApprovalTableState = (): BIApprovalTableState => ({
  rows: [],
  loading: false,
  pagination: defaultTablePagination(),
});

export const defaultParametersState = (): BIParametersState => ({
  initialized: false,
  expandedFiltersLoaded: false,
  filter: defaultParametersFilter(),
  filterOptions: defaultParametersFilterOptions(),
  table: defaultParametersTableState(),
});

export const defaultApprovalState = (): BIApprovalState => ({
  initialized: false,
  filter: defaultApprovalFilter(),
  filterOptions: defaultApprovalFilterOptions(),
  table: defaultApprovalTableState(),
});

export const defaultBIControlPanelModel = (): BIControlPanelModel => ({
  parameters: defaultParametersState(),
  approval: defaultApprovalState(),
});
